import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Accordion from 'layout/atoms/Accordion/Accordion';
import Button from 'layout/atoms/Button/Button';
import Card from 'layout/atoms/Card/Card';
import TableGrid, { Body, Cell, Head, Row } from 'layout/atoms/TableGrid/TableGrid';
import { closeSidebar, openModal } from 'store/layoutSlice';
import { selectSpecificationPreviewItem } from 'store/specificationPreviewSlice';
import { getConsumptionTypeLabel } from 'utils/convertMetrics';
import styles from './ComponentAccordionCard.module.scss';
function ComponentAccordionCard({ component, specificationId }) {
    var _a, _b;
    const { t, i18n } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const history = useHistory();
    const specificationPreview = useSelector(selectSpecificationPreviewItem);
    const sizes = (_b = (_a = specificationPreview.sizes) === null || _a === void 0 ? void 0 : _a.edges) !== null && _b !== void 0 ? _b : [];
    const handleSpecificationLink = (route) => {
        if ((specificationPreview === null || specificationPreview === void 0 ? void 0 : specificationPreview.state) === 'DRAFT') {
            dispatch(openModal({
                name: 'specificationCreator',
                data: { id: specificationId, activeTab: 'component-consumptions' },
            }));
        }
        else {
            dispatch(closeSidebar({ name: 'specificationPreview' }));
            setTimeout(() => history.push(route), 300 - 10);
        }
    };
    const componentHeader = (component) => {
        return (React.createElement("div", { className: styles.wrap },
            React.createElement("p", null, component.name),
            component.isConsumptionSet &&
                !component.consumptionVariedOnSize &&
                `${component.consumptions.edges[0].node.consumption} ${getConsumptionTypeLabel(component.productCategory.consumptionType, i18n)}`,
            component.isConsumptionSet &&
                component.consumptionVariedOnSize &&
                t('consumptionVariedOnSizeTrue'),
            !component.isConsumptionSet && (React.createElement(Button, { theme: "ghost", onClick: () => handleSpecificationLink(`/specifications/details/${specificationId}/component-consumptions`) }, t('common:complete')))));
    };
    return (React.createElement(Card, { size: "xs", bgColor: component.isConsumptionSet ? 'white' : 'alert' }, component.isConsumptionSet && component.consumptionVariedOnSize ? (React.createElement(Accordion, { key: component.id, header: componentHeader(component) },
        React.createElement("div", { className: styles.details },
            React.createElement(TableGrid, { columns: sizes.map(() => ['80px', '1fr']) },
                React.createElement(Head, null,
                    React.createElement(Row, { head: true }, sizes.map((size) => (React.createElement(Cell, { key: size.node.sizeName.id }, size.node.sizeName.name))))),
                React.createElement(Body, null,
                    React.createElement(Row, null, component.consumptions.edges.map((value) => (React.createElement(Cell, { key: value.node.id },
                        value.node.consumption,
                        ' ',
                        getConsumptionTypeLabel(component.productCategory.consumptionType, i18n)))))))))) : (componentHeader(component))));
}
export default ComponentAccordionCard;
